import format from 'root-core/utils/text/stringFormatFilter.js'
import * as validations from './validations.js'
import spacecase from 'root-core/utils/text/spacecase.js'
import parseUserSuppliedDate from './parseUserSuppliedDate.js'

export default function (config) {

  function present (field) {
    return validations.required((value, object, property) =>
      format(
        config.errorMessages.required,
        field || spacecase(property)
      )
    )
  }

  function parseDate (date) {
    if (typeof date === 'string') {
      return parseUserSuppliedDate(date, config.dateFormat)
    }
  }

  function date (value) {
    const date = parseDate(value)
    if (!date) {
      return format(
        config.errorMessages.dateFormat,
        config.dateFormat
      )
    }
  }

  function minLength (length, field) {
    return function (value, is, object, property) {
      if (value.length < length) {
        return format(
          config.errorMessages.minLength,
          length,
          field || spacecase(property)
        )
      }
    }
  }

  function maxLength (length, field) {
    return function (value, is, object, property) {
      if (value.length > length) {
        return format(
          config.errorMessages.maxLength,
          length,
          field || spacecase(property)
        )
      }
    }
  }

  function pattern (regex, field) {
    return function (value, is, object, property) {
      if (!regex.test(value)) {
        return format(
          config.errorMessages.pattern,
          field || spacecase(property)
        )
      }
    }
  }

  return {
    present,
    parseDate,
    date,
    minLength,
    maxLength,
    pattern,
  }
}
